<template>
    <div class="d-flex flex-wrap align-items-end" >
        <full-image-dialog ref='fullImageDialog' :thread='owner' :in_image='full_image' :show_controls='true' />

        <document-download-dialog ref='documentDownloadDialog' :thread='owner' :in_document_download='document_download' />

        <template v-if='in_images && in_images.length'>
            <div :key='"imaged-" + image.image_id' class='attachment-container d-flex flex-column mr-2 mb-2' v-for='(image, image_index) in in_images'>
                <div class="p-1 m-1 bg-light document-upload__container" v-on:click='showFullImageDialog(image.image_id, owner.archived)'>
                    <img class='thumbnail-image mr-2 border' src='/img/icon-attachment-doc.svg' width='50' height='50'>
                    <p v-if='show_image_names' class='align-self-center' style='word-wrap: inherit'>{{ image.image.name ? image.image.name : getShortImageDownloadName(owner, image.image.id)}}</p>
                </div>
                <button v-if='allow_delete' class="btn-delete-attachment" v-on:click.prevent='removeImage(in_images, image_index)'>{{ $t('translations.remove') }}</button>
                <template v-if='show_selector && getImageData(image.image.id)'>
                    <a v-if='show_download' v-on:click='initImageDownload($event, getImage(image.image.id), getImageDownloadName(owner, image.image_id))'  class='mt-2 btn btn-primary btn-round' :href='getImageData(image.image.id)' :download='getImageDownloadName(owner, image.image_id)'>{{ $t('translations.download')}}</a>
                    <div v-else-if='selected_images'>
                        <label>
                            <input type='checkbox' v-on:change='$emit("selected-image-update", {id: image.image.id, checked: $event.target.checked})' :value='image.image.id' v-model='selected_images' class='pl-1 ml-1'> Include
                        </label>
                    </div>
                </template>
            </div>
        </template>
        <template v-else-if='in_attached_images && in_attached_images.length'>
            <div :key='"imaged-" + image_index' class='attachment-container d-flex flex-column mr-2 mb-2' v-for='(image, image_index) in in_attached_images'>
                <div class="p-1 m-1 bg-light document-upload__container">
                    <img v-if='show_images && in_attached_images[image_index].tn_canvas.toDataURL' ref='imagePreview' class='mt-auto image-preview' :src='in_attached_images[image_index].tn_canvas.toDataURL("image/jpeg")'>
                    <img v-else class='mr-2 border' src='/img/icon-attachment-doc.svg' width='50' height='50'>
                    <p v-if='show_image_names' class='align-self-center' style='word-wrap: inherit'>{{image.file_name}}</p>
                </div>
                <button v-if='allow_delete_attached' class="mt-auto btn btn-primary btn-round" v-on:click.prevent='in_attached_images.splice(image_index, 1)'>{{ $t('translations.remove') }}</button>
            </div>
        </template>
        <template v-if='in_documents && in_documents.length'>
            <div :key='"documentd-" + document.document_id' class='attachment-container d-flex flex-column mr-2 mb-2' v-for='(document, document_index) in in_documents'>
                <div class="p-1 m-1 bg-light document-upload__container" v-on:click='showDocumentDownloadDialog(document.document, owner.archived)'>
                    <img class='thumbnail-image mr-2 border' src='/img/icon-document.svg' width='50' height='50'>
                    <p class='align-self-center'>{{document.document.name}}</p>
                </div>
                <button v-if='allow_delete' class="btn-delete-attachment" v-on:click.prevent='removeDocument(in_documents, document_index)'>{{ $t('translations.remove') }}</button>
                
                <template v-if='show_selector && getDocumentData(document.document.id) && owner && owner.user'>
                    <a v-if='show_download' v-on:click='initDocumentDownload($event, getDocument(document.document.id), document.document.name)'  class='mt-2 btn btn-primary btn-round' :href='getDocumentData(document.document.id)' :download='document.document.name'>{{ $t('translations.download') }}</a>
                    <div v-else-if='selected_documents'>
                        <label>
                            <input type='checkbox' v-on:change='$emit("selected-document-update", {id: document.document.id, checked: $event.target.checked})' :value='document.document.id' v-model='selected_documents' class='pl-1 ml-1'> Include
                        </label>
                    </div>
                </template>
            </div>
        </template>
        <template v-else-if='in_attached_documents && in_attached_documents.length'>
            <div :key='"documentd-" + document_index' class='attachment-container d-flex flex-column mr-2 mb-2' v-for='(document, document_index) in in_attached_documents'>
                <div class="p-1 m-1 bg-light document-upload__container">
                    <img class='mr-2 border' src='/img/icon-document.svg' width='50' height='50'>
                    <p class='align-self-center'>{{document.file_name}}</p>
                </div>
                <button v-if='allow_delete_attached' class="mt-auto btn btn-primary btn-round" v-on:click.prevent='in_attached_documents.splice(document_index, 1)'>{{ $t('translations.remove') }}</button>
            </div>
        </template>
        <div v-if='attached_form' class="d-flex flex-column mr-1">
            <div class="p-1 bg-light m-1 document-upload__container">
                <img ref='imagePreview' class='mt-auto align-self-center' src='/img/icon-document.svg' width='50' height='50'>
                <p class='align-self-center'>{{attached_form.title}}</p>
            </div>
            <button class="mt-auto btn btn-primary btn-round" v-on:click.prevent='$emit("remove-form")'>{{ $t('translations.remove') }}</button>
        </div>
        <!-- For reference this is what the non-icon thumbnails looked like: 

        <img :key='"image-" + image_index' :width='image.image.tn_width' :height='image.image.tn_height' v-on:click='showFullImageDialog(image.image_id, owner.archived)' class='thumbnail-image mr-2 border' v-for='(image, image_index) in item.message_image' :src="getImageSrc(image.image.id, true)">

        -->

    </div>
</template>

<script>
	export default {
        extends: app.base.attachmentHelper,
		props: {
            in_images: {
                default: null
            },
            in_attached_images: {
                default: null
            },
            in_documents: {
                default: null
            },
            in_attached_documents: {
                default: null
            },
            allow_delete: {
                default: true
            },
            owner: {
            },
            in_image_data: {
                default: null
            },
            in_document_data: {
                default: null
            },
            show_images: {
                default: false
            },
            show_image_names: {
                default: true
            },
            show_download: {
                default: false
            },
            show_selector: {
                default: false
            },
            allow_delete_attached: {
                default: false
            },
            attached_form: {
                default: null
            },
            in_api_load_prefix: {
                default: "message", // can be formsubmission
            },
		},
		data: function() {
			return {
                selected_documents: [],
                selected_images: [],
            };
		},
		computed: {
            
        },
		mounted() {
            // The parent object will have already loaded all the thumbnail data, in most cases,
            // so we can use that rather than reloading it.
            if(this.in_image_data) {
                this.image_data = this.in_image_data;
            }
            if(this.in_document_data) {
                this.document_data = this.in_document_data;
            }
            this.api_load_prefix = this.in_api_load_prefix;
            for(var index in this.in_images) {
                
                this.selected_images.push(this.in_images[index].image_id);
                this.$emit("selected-image-update", {id: this.in_images[index].image_id, checked: true});
            }
            for(var index in this.in_documents) {
                this.selected_documents.push(this.in_documents[index].document_id);
                this.$emit("selected-document-update", {id: this.in_documents[index].document_id, checked: true});
            }
        },
        watch: {
            
        },
		methods: {
            // NOTE: The next four functions are imported from the CopyDialog, and that works by pre-loading
            // all the attachment data, which is probably overkill, and the document downloads especially, can
            // be handled differently, but refactoring that as part of the attachment display was too much at
            // the time. So just note that these four functions get the image and document from the document_data
            // and image_data pre-load arrays and are only used for the download button in the CopyDialog version.
            getDocument(id) {
                return this.document_data.find((obj) => {return obj.id == id});
            },
            getDocumentData(id) {
                var document = this.getDocument(id);
                if (document) {
                    return document.data;
                }
                return null;
            },
            getImage(id) {
                return this.image_data.find((obj) => {return obj.id == id});
            },
            getImageData(id) {
                var image = this.getImage(id);
                if (image) {
                    return image.data;
                }
                return null;
            },
            // END NOTE
            removeImage(image_array, index) {
                //console.info(image_array, index);
                this.$modal.show('dialog', {
                    title: this.$t('translations.remove_image'),
                    text: this.$t('translations.remove_image_confirmation'),
                    buttons: [
                    {
                        title: this.$t('translations.okay'),
                        handler: () => {
                            this.$modal.hide('dialog');
                            
                            axios.delete(this.$root.apiBase + '/' + this.api_load_prefix + 'image/' + image_array[index].image_id).then((res) => {
                                var image_cache_index = this.image_data.findIndex((obj) => {return obj.id == image_array[index].image_id});
                                if(image_cache_index !== -1) {
                                    this.image_data.splice(image_cache_index, 1);
                                }
                                image_array.splice(index, 1);
                            }).catch(error => {
                                this.setLoading(false);
                                this.handleError(error, "load");
                            });
                        },
                        default: true
                    },
                    {
                        title: this.$t('translations.cancel'),
                        handler: () => {
                            this.$modal.hide('dialog');
                        }
                    }]});
            },
            removeDocument(document_array, index) {
                //console.info(document_array, index);
                this.$modal.show('dialog', {
                    title: this.$t('translations.remove_document'),
                    text: this.$t('translations.remove_document_confirmation'),
                    buttons: [
                    {
                        title: this.$t('translations.okay'),
                        handler: () => {
                            this.$modal.hide('dialog');
                            
                            axios.delete(this.$root.apiBase + '/' + this.api_load_prefix + 'document/' + document_array[index].document_id).then((res) => {
                                var document_cache_index = this.document_data.findIndex((obj) => {return obj.id == document_array[index].document_id});
                                if(document_cache_index !== -1) {
                                    this.document_data.splice(document_cache_index, 1);
                                }
                                document_array.splice(index, 1);
                            }).catch(error => {
                                this.setLoading(false);
                                this.handleError(error, "load");
                            });
                        },
                        default: true
                    },
                    {
                        title: this.$t('translations.cancel'),
                        handler: () => {
                            this.$modal.hide('dialog');
                        }
                    }]});
            },
        }
    }
</script>
